import { schema } from 'normalizr';
import { createAction } from 'redux-actions';
import apiResourceBuilder from '../../../../common/utils/apiResourceBuilder';
import entityActionCreator from '../../../../common/utils/entityActionCreator';

export const legislatorsApi = apiResourceBuilder('legs/legislators');

export const legislatorsSchema = new schema.Entity(
  'legislators',
  {},
  { idAttribute: 'id' }
);

export const LegislatorsActionTypes = {
  CLEAR: `ENTITY/ENTITY_CLEAR`,
};

const reducerActions = {
  [LegislatorsActionTypes.CLEAR]: () => ({}),
};

export const lookUpActionReducer = reduceActions => (state = {}, action) => {
  const reduceAction = reduceActions[action.type];
  return typeof reduceAction === 'function'
    ? reduceAction(state, action)
    : state;
};

export const legislatorsReducer = lookUpActionReducer(reducerActions);

export default {
  ...entityActionCreator({ schema: legislatorsSchema, api: legislatorsApi }),
  clear: createAction(LegislatorsActionTypes.CLEAR),
};



// WEBPACK FOOTER //
// ./src/App/account/actions/legislators/index.js